export const MENU_ROUTES = {
  HOME: 'home',
  PRODUCTS: 'products',
  ORDERS: 'orders',
  PRODUCTION: 'production',
  IMPORT_HISTORY: 'import-history',
  EDIT: 'edit',
};
export const HOME = {
  LIST: `/${MENU_ROUTES.HOME}`,
  DETAIL: `/${MENU_ROUTES.HOME}/${MENU_ROUTES.EDIT}/:id`,
};

export const ORDER_ROUTES = {
  LIST: `/${MENU_ROUTES.ORDERS}`,
  CREATE: `/${MENU_ROUTES.ORDERS}/import`,
  DETAIL: `/${MENU_ROUTES.ORDERS}/${MENU_ROUTES.EDIT}/:id`,
};

export const PRODUCT_ROUTES = {
  LIST: `/${MENU_ROUTES.PRODUCTS}`,
  EDIT: `/${MENU_ROUTES.PRODUCTS}/${MENU_ROUTES.EDIT}/:id`,
  CREATE: `/${MENU_ROUTES.PRODUCTS}/create`,
  IMPORT: `/${MENU_ROUTES.PRODUCTS}/import`,
  LIST_IMPORT_PRODUCT: `/${MENU_ROUTES.PRODUCTS}/import/list`,
  LIST_PRODUCT_NOT_LINK_ORDER: `/${MENU_ROUTES.PRODUCTS}/listProductNotLinkOrder`,
};

export const PRODUCTION_ROUTES = {
  LIST: `/${MENU_ROUTES.PRODUCTION}`,
  IMPORT: `/${MENU_ROUTES.PRODUCTION}/import`,
  HISTORY: `/${MENU_ROUTES.PRODUCTION}/history`,
};

export const IMPORT_HISTORY_ROUTES = {
  LIST: `/${MENU_ROUTES.IMPORT_HISTORY}`,
};

export const ROUTES = {
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password/:code',
  CHECK_TOKEN_RESET_PASSWORD: '/check-code-reset-password/:code',
  NOTFOUND: 'not-found',
  COMING_SOON: '/coming-soon',
};
